import { MsArrowTop as _ } from "@sunrise/icons";
import { screenSizeDetection as d } from "@sunrise/shared";
import { ElementTrackingIds as y, track as u, NOT_SET as e } from "@sunrise/tracking";
import { debounce as p } from "lodash-es";
import { defineComponent as f, ref as T, onMounted as h } from "vue";
const S = f({
  name: "MsBackToTopButton",
  components: { MsArrowTop: _ },
  setup() {
    const { isScreenL: r } = d(), n = T(!1), s = p(() => i(), 10);
    h(() => {
      a() && (i(), window.addEventListener("scroll", s));
    });
    function i() {
      const t = window.scrollY, o = l();
      n.value = t >= o;
    }
    function a() {
      const t = document.body.scrollHeight, o = l();
      return t > o;
    }
    const c = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      }), m();
    };
    function l() {
      return window.innerHeight * 4;
    }
    const m = () => {
      const t = {
        mslayer_element_data_id: y.STICKY_NAVIGATION,
        mslayer_element_text: "Sticky_Navigation",
        mslayer_element_type_text: "Back to Top",
        mslayer_element_count: e,
        mslayer_element_variant: "default",
        mslayer_element_body_type: "overlay",
        mslayer_element_position: e,
        mslayer_element_id: e,
        mslayer_affiliate_id: e,
        mslayer_element_company_name: e,
        mslayer_element_detail_start_date: e
      };
      u(t);
    };
    return {
      scrollTop: c,
      visible: n,
      isScreenL: r
    };
  }
});
export {
  S as default
};
